import { DisplayParameter, MenuItem, NavtreeItem, NavtreeState, ParameterItem, ReportPageRoute } from 'app/shared/models';
import { evaluateParameterCondition } from 'app/shared/parameter-condition';
import { Actions as NavtreeAction, Type as NavtreeActionType } from 'app/state/actions/navtree.actions';
import { cloneDeep } from 'lodash-es';

const initialState: NavtreeState = {
  items: [],
  routes: [],
  displayParameters: [],
  loading: false,
  isHandset: false,
  isTablet: false,
  sidebarCollapsed: false,
};

export function reducer(state: NavtreeState = initialState, action: NavtreeAction): NavtreeState {

  switch (action.type) {
    case NavtreeActionType.LOAD_NAVTREE_CANCELED: {
      return { ...state, loading: false };
    }
    case NavtreeActionType.LOAD_NAVTREE_SUCCESS: {
      const routes: ReportPageRoute[] = [];
      const items = action.payload.find(r => r.type === 'Tab')?.items ?? [];
      const pageRoutes = getRoutes(items, routes);
      const displayParameters = getDisplayParameters(action.payload);

      return Object.assign({}, state, {
        items: action.payload,
        routes: pageRoutes,
        displayParameters: displayParameters,
        loading: false,
      });
    }
    case NavtreeActionType.LOAD_NAVTREE: {
      return Object.assign({}, state, {
        loading: true
      });
    }
    case NavtreeActionType.UPDATE_MISSING_VISIBILITY: {
      return {
        ...state,
        items: state.items.map(navtreeItem => {
          const filteredMenuItems = action.payload.filter(menuItem => menuItem.displayType === navtreeItem.type);

          if (filteredMenuItems.length === 0) {
            return navtreeItem;
          }

          const uniqueItems = Array.from(
            new Map(
              [...navtreeItem.items, ...filteredMenuItems].map(item => [item.key, item])
            ).values()
          );

          return {
            ...navtreeItem,
            items: uniqueItems
          };
        })
      };
    }
    case NavtreeActionType.UPDATE_VISIBILITY: {
      const items: NavtreeItem[] = cloneDeep(state.items);
      const parameters = { ...action.params };
      const updatedItems = action.items ? [...action.items] : [];
      if (updatedItems) {
        updatedItems.forEach(updateItem => {
          items.forEach(treeItem => {
            const menuItem = treeItem.items.find(i => i.key === updateItem.key);
            if (menuItem) {
              if (menuItem.visible !== updateItem.visible) {
                menuItem.visible = updateItem.visible;
              }
            }
          });
        });
      } else {
        const companyParameters = parameters.companyParameters.find(cp => cp.companyId === parameters.currentCompanyId);
        const currentParameters = companyParameters ? companyParameters.parameters : [] as ParameterItem[];
        items.forEach(treeItem => {
          treeItem.items.forEach(menuItem => {
            if (menuItem.condition && menuItem.condition.context === 'Frontend') {
              menuItem.visible = evaluateParameterCondition(menuItem.condition, currentParameters);
            }
          });
        });
      }

      return Object.assign({}, state, {
        items: items
      });
    }
    case NavtreeActionType.UPDATE_ISHANDSET: {
      return { ...state, isHandset: action.payload };
    }
    case NavtreeActionType.UPDATE_ISTABLET: {
      return { ...state, isTablet: action.payload };
    }
    case NavtreeActionType.TOGGLE_SIDEBAR: {
      return { ...state, sidebarCollapsed: !state.sidebarCollapsed };
    }
    default: {
      return state;
    }
  }

}

function getRoutes(pages: MenuItem[], routes: ReportPageRoute[]) {
  pages.forEach(page => {
    if (page.key) {
      const route: ReportPageRoute = { pageKey: page.key, route: page.route };
      routes.push(route);
      if (page.children.length > 0) {
        routes = getRoutes(page.children, routes);
      }
    }
  });
  return routes;
}

function getDisplayParameters(navItems: NavtreeItem[]) {
  const parameters: DisplayParameter[] = [];
  navItems.forEach(i => {
    i.items.forEach(p => {
      if (p.displayParameters != null && p.displayParameters.length > 0) {
        p.displayParameters.forEach(p => { parameters.push(p); });
      }
    });
  });
  return parameters;
}
